import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Tooltip from '@material-ui/core/Tooltip';
import Box from '@material-ui/core/Box';
import Slide from '@material-ui/core/Slide';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Fab from '@material-ui/core/Fab';
import { makeStyles } from '@material-ui/core/styles';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';

const useStyles = makeStyles((theme) => ({
    main: {
        position: "fixed",
        right: "5.5em",
        bottom: "0.5em",
        zIndex: 99,
        "@media print": {
            display: "none !important"
        }
    },
    button: {
        border: "var(--black) 1px solid",
        padding: "4px",
        boxShadow: "none",
        background: "var(--white)",
    },
    icon: {
        fontSize: "4em"
    }
}));

const ScrollToTop = function () {
    const classes = useStyles();
    const { pathname } = useLocation();

    const trigger = useScrollTrigger({ threshold: 1, disableHysteresis: true });

    const scroll = () => {
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        scroll();
    }, [pathname]);

    return (
    <Slide appear={false} direction="up" in={trigger}>
        <Box className={classes.main}>
            <Tooltip title="Scroll to top">
                <Fab aria-label="scroll to top" onClick={scroll} className={classes.button}>
                    <ExpandLessIcon className={classes.icon} />
                </Fab>
            </Tooltip>
        </Box>
    </Slide>);
};

export default ScrollToTop;